import {useEffect,useState} from "react";
import realtimeDB from "../Utils/api";

const useReseñas=()=>
{
    const [Reviews, setReviews] = useState([]);
    const [Promedio, setPromedio] = useState(undefined);
    const [GraphLine, setGraphLine] = useState(undefined)
    const [Loading, setLoading] = useState(true);
    const [Sugerencias, setSugerencias] = useState([])

    useEffect(() => 
    {
        const CustomersRef=realtimeDB.ref("/Reseñas");

        CustomersRef.on("value",snapshot =>
        {
            let reviews = [];
            let Sugerencias = [];

            var promedio = {
                Atencion: null,
                Bebida: null,
                Comida: null,
                Ambientacion: null,
            }

            snapshot.forEach(customer =>
            {
                const {Atencion,Bebida,Comida,Ambientacion,Sugerencia,Fecha,Mesa,Telefono,Cupon}=customer.val();
                
                reviews.push({
                    Atencion,
                    Bebida,
                    Comida,
                    Ambientacion,
                    Sugerencia,
                    Fecha,
                    Mesa,
                    Telefono,
                    Cupon,
                });

                promedio.Atencion += Atencion;
                promedio.Bebida += Bebida;
                promedio.Comida += Comida;
                promedio.Ambientacion += Ambientacion;

                if(Sugerencia) Sugerencias.push({Sugerencia,Fecha,Mesa});
            });

            promedio.Atencion = Number(Number(promedio.Atencion / reviews.length).toFixed(2))  ;
            promedio.Bebida = Number(Number(promedio.Bebida / reviews.length).toFixed(2)) ;
            promedio.Comida = Number(Number(promedio.Comida / reviews.length).toFixed(2)) ;
            promedio.Ambientacion = Number(Number(promedio.Ambientacion / reviews.length).toFixed(2)) ;


            const data = 
            {
                labels: ['Ambientación', 'Atención' , 'Bebida', 'Comida'],
                datasets: [
                    {
                        label: 'Puntuación',
                        data: [ promedio.Ambientacion , promedio.Atencion , promedio.Bebida , promedio.Comida ],
                        backgroundColor: ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 206, 86, 0.2)', 'rgba(75, 192, 192, 0.2)'],
                        borderColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)'],
                        borderWidth: 1,
                    },
                ],
            };

            const Fechas = Array.from(new Set(reviews.map(review => review.Fecha.split(" ")[0])));
         
            var AmbientacionLine = [];
            var AtencionLine = [];
            var BebidaLine = [];
            var ComidaLine = [];

            for (const Fecha of Fechas)
            {
                
                const ReviewsDelDia = reviews.filter(review => review.Fecha.includes(Fecha));
                const PromedioAmbientacion = Number(Number(ReviewsDelDia.reduce((a,b) => a + b.Ambientacion,0) / ReviewsDelDia.length).toFixed(2));
                const PromedioAtencion = Number(Number(ReviewsDelDia.reduce((a,b) => a + b.Atencion,0) / ReviewsDelDia.length).toFixed(2));
                const PromedioBebida = Number(Number(ReviewsDelDia.reduce((a,b) => a + b.Bebida,0) / ReviewsDelDia.length).toFixed(2));
                const PromedioComida = Number(Number(ReviewsDelDia.reduce((a,b) => a + b.Comida,0) / ReviewsDelDia.length).toFixed(2));

                AmbientacionLine.push(PromedioAmbientacion);
                AtencionLine.push(PromedioAtencion);
                BebidaLine.push(PromedioBebida);
                ComidaLine.push(PromedioComida);
            }

            var LineGraph = 
            {
                labels: Fechas,
                datasets:
                [
                    {
                        label:"Ambientación",
                        fill:false,
                        borderColor:"rgb(75, 192, 192)",
                        tension:0.1,
                        data:AmbientacionLine
                    },
                    {
                        label:"Atención",
                        fill:false,
                        borderColor:"rgb(255, 99, 132)",
                        tension:0.1,
                        data:AtencionLine
                    },
                    {
                        label:"Bebida",
                        fill:false,
                        borderColor:"rgb(255, 206, 86)",
                        tension:0.1,
                        data:BebidaLine
                    },
                    {
                        label:"Comida",
                        fill:false,
                        borderColor:"rgb(54, 162, 235)",
                        tension:0.1,
                        data:ComidaLine
                    }
                ]
                
            }
          
            setSugerencias(Sugerencias.reverse());
            setPromedio(data);
            setReviews(reviews.reverse());
            setGraphLine(LineGraph);
            setLoading(false);
        });

        return ()=> CustomersRef.off();
    }, [])

    return {Reviews,Promedio,Loading,Sugerencias,GraphLine};
}

export default useReseñas;